import styled from "@emotion/styled"
import { Attribute, LocatorStationsWrapper } from "api"
import LocatorLayout from "components/Locator/LocatorLayout"
import { getLocatorQueryParams } from "components/Locator/useGetLocatorQueryParams"

import { LayoutContext } from "contexts/LayoutProvider"
import { LocatorMapType } from "contexts/MapLocatorTypeProvider"
import HomePageLinkUI from "layout/HomePageLinkUI"
import { getParentsArray } from "lib/utils"
import dynamic from "next/dynamic"
import SmallChargeIcon from "public/icons/pazCharge/Logo/smallChargeLogo"
import { useContext, useEffect, useState } from "react"
import colors from "theme/colors"
import { CustomBreadcrumbs, NewText, TitleWithLine, extractProperty } from "ui"

const MapComponent = dynamic(() => import("map-feature/MapComponent"), {
    ssr: false,
    loading: () => (
        <StyledMapPlaceholder>
        </StyledMapPlaceholder>
    )
});

const StyledContainer = styled.div`
background: linear-gradient(0.02deg, rgba(21, 62, 105, 0.06) 88.04%, rgba(21, 62, 105, 0) 91.84%);
    ${(props) => props.theme.breakpoints.down("md")} {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 146px 60px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 220px 80px;
  }
`
const StyledBreadCrumbsWrapper = styled.div`
        ${(props) => props.theme.breakpoints.down("md")} {
    padding-bottom: 20px;
  }
`
const StyledWrapper = styled.div`
    padding-left: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 0px;
    padding-bottom: 40px;
  }
      ${(props) => props.theme.breakpoints.up("lg")} {
    padding-bottom: 80px;
  }
`
const StyledTitleAndText = styled.div`
    ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`

const StyledMapPlaceholder = styled.div`
  background-color: #f5f5f5;
  height: 100%;
  width: 100%;
`

const StyledMapWrapper = styled.div`
  max-height: auto;
  height: auto;
  overflow: hidden;
  min-height: 540px;
  ${(props) => props.theme.breakpoints.up("md")} {
    max-height: 770px;
    height: 770px;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
        height: 1000px;
        max-height: 1000px;
  }
`

type Props = {
    data: any,
    metadata: Attribute[]
    stations: LocatorStationsWrapper
    pageName: string
}

function MapStationsCharge({ data, metadata, stations, pageName }: Props) {
    const [chargeIds, setChargeIds] = useState<number[] | null>(null)
    const [initialFiltersAreReady, setInitialFiltersAreReady] = useState(false)
    const { GRAPHQL_URL } = useContext(LayoutContext)
    const mainTitle = extractProperty(data, "mainTitle")
    const subTitle = extractProperty(data, "subTitle")
    const parents = getParentsArray(data.page, 3)
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        setTimeout(() => setIsMounted(true), 1000)
    }, [])

    useEffect(() => {
        console.log({ isMounted })
    }, [isMounted])


    useEffect(() => {
        const isProduction = !GRAPHQL_URL?.includes("qa")
        const id = !isProduction ? 18 : 19
        const result = getLocatorQueryParams()
        const metadata = result.metadata || []
        setChargeIds([id, ...metadata])
        setTimeout(() => {
            setInitialFiltersAreReady(true)
        }, 100)
    }, [GRAPHQL_URL])

    return (
        <>
            <StyledContainer>
                <StyledWrapper>
                    <StyledBreadCrumbsWrapper>
                        <CustomBreadcrumbs
                            current={{ title: pageName || "", url: `/` }}
                            parents={[{
                                title: <HomePageLinkUI title="ראשי" icon={<SmallChargeIcon />} />,
                                url: "/pazcharge"
                            }, ...parents.slice(0, -1)]}
                        />
                    </StyledBreadCrumbsWrapper>
                    <StyledTitleAndText>
                        <TitleWithLine
                            component={"h1"}
                            largeDesktopFontSize={48}
                            largeDesktopLineHeight="50px"
                            titleFontSize={34}
                            desktopLineHeight={"36px"}
                            mobileTitleFontSize={24}
                            mobileLineHeight={"28px"}
                            desktopFontWeight={500}
                            title={mainTitle}
                            titleColor={colors.black}
                            noMobileMargin
                        />
                        <NewText
                            component={"p"}
                            largeDesktopFontSize={18}
                            largeDesktopLineHeight="20px"
                            desktopFontSize={18}
                            desktopLineHeight={"20px"}
                            desktopFontWeight={400}
                            mobileFontSize={16}
                            mobileLineHeight={"18px"}
                            mobileFontWeight={400}
                        >
                            {subTitle}
                        </NewText>
                    </StyledTitleAndText>
                </StyledWrapper>

                <LocatorLayout
                    metadata={metadata}
                    defaultFilterIds={chargeIds ? chargeIds : null}
                    appType={LocatorMapType.Charge}
                >
                    <StyledMapWrapper>
                        {isMounted ? (
                            <MapComponent
                                metadata={metadata}
                                stations={stations}
                                initialFiltersAreReady={initialFiltersAreReady}
                            />
                        ) : (
                            <StyledMapPlaceholder>
                            </StyledMapPlaceholder>
                        )}
                    </StyledMapWrapper>
                </LocatorLayout>
            </StyledContainer>
        </>
    );
}

export default MapStationsCharge;
